"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createProject;
const either_1 = require("../../../types/either");
const CrudCoreAxios_1 = require("../../CrudCoreAxios");
const helpers_1 = require("../helpers");
function createProject(flashId, flashToken, sku, options, startingPageCount) {
  return __awaiter(this, void 0, void 0, function* () {
    const ccAxios = (0, CrudCoreAxios_1.getInstance)(flashToken);
    if (ccAxios.isLeft()) {
      return (0, either_1.left)(ccAxios.value);
    }
    try {
      const response = yield ccAxios.value.post(`/api/projects?flashId=${flashId}`, {
        sku,
        options,
        startingPageCount
      });
      return (0, either_1.right)(response.data);
    } catch (error) {
      return (0, either_1.left)((0, helpers_1.getAxiosError)(error));
    }
  });
}